module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "panel panel-default panel-search"
  }, [_c('el-form', {
    attrs: {
      "inline": true
    }
  }, [_c('el-form-item', [_c('div', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('el-select', {
    staticClass: "formitem-label",
    staticStyle: {
      "width": "120px"
    },
    model: {
      value: (_vm.dateRangeType),
      callback: function($$v) {
        _vm.dateRangeType = $$v
      },
      expression: "dateRangeType"
    }
  }, [_c('el-option', {
    attrs: {
      "value": "activeOn",
      "label": "激活时间"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": "useOn",
      "label": "使用时间"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": "createOn",
      "label": "记录时间"
    }
  })], 1)], 1), _vm._v(" "), _c('el-date-picker', {
    attrs: {
      "type": "daterange",
      "range-separator": "至",
      "start-placeholder": "开始日期",
      "end-placeholder": "结束日期",
      "value-format": "yyyy-MM-dd HH:mm:ss"
    },
    model: {
      value: (_vm.dateRange),
      callback: function($$v) {
        _vm.dateRange = $$v
      },
      expression: "dateRange"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "统计维度"
    }
  }, [_c('el-checkbox-group', {
    on: {
      "change": _vm.search
    },
    model: {
      value: (_vm.page.query.dimensions),
      callback: function($$v) {
        _vm.$set(_vm.page.query, "dimensions", $$v)
      },
      expression: "page.query.dimensions"
    }
  }, _vm._l((_vm.dimensionOptions), function(item) {
    return _c('el-checkbox', {
      key: item[1],
      attrs: {
        "label": item[1]
      }
    }, [_vm._v(_vm._s(item[0]))])
  }), 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    directives: [{
      name: "keycode",
      rawName: "v-keycode",
      value: ('ENTER'),
      expression: "'ENTER'"
    }],
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("查询")])], 1)], 1)], 1), _vm._v(" "), _c('v-table', {
    ref: "table",
    attrs: {
      "page": _vm.page,
      "table-minheight": 450,
      "page-size": -1
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "username",
      "label": "优惠券"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_vm._v(_vm._s(row.promotionName))]
      }
    }])
  }), _vm._v(" "), (_vm.hasDimension('dispatchChannelId')) ? _c('el-table-column', {
    attrs: {
      "prop": "username",
      "label": "派发渠道"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_vm._v(_vm._s(row.dispatchChannelName))]
      }
    }], null, false, 3887241675)
  }) : _vm._e(), _vm._v(" "), (_vm.hasDimension('activeOn')) ? _c('el-table-column', {
    attrs: {
      "prop": "username",
      "label": "激活日期",
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_vm._v(_vm._s(row.activeOn))]
      }
    }], null, false, 4099566418)
  }) : _vm._e(), _vm._v(" "), (_vm.hasDimension('useOn')) ? _c('el-table-column', {
    attrs: {
      "prop": "username",
      "label": "使用日期",
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_vm._v(_vm._s(row.useOn))]
      }
    }], null, false, 975702365)
  }) : _vm._e(), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "totalNum",
      "label": "总量",
      "width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "activeNum",
      "label": "激活量",
      "width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "useNum",
      "label": "使用量",
      "width": "80"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-64854590","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/app/report/CouponReport.vue
// module id = 343
// module chunks = 0